<template>
    <div class="root">
        <v-subheader>
            {{$vuetify.t('$vuetify.statistics.title')}}
        </v-subheader>

        <table>
            <thead>
                <tr>
                    <td class="left">{{$vuetify.t('$vuetify.statistics.zone')}}</td>
                    <td>
                        <a href="#" @click.prevent="dayLeft">◀</a>
                        <template  v-if="isToday">
                            {{$vuetify.t('$vuetify.statistics.today')}}
                        </template>
                        <template v-else>
                            {{ formattedDay }}
                        </template>
                        <a href="#" @click.prevent="dayRight">▶</a>
                    </td>
                    <td>{{$vuetify.t('$vuetify.statistics.total')}}</td>
                </tr>
            </thead>
            <tr v-for="zone in $store.state.zoneStats" :key="zone.id">
                <td class="left">{{zone.name}}</td>
                <td>{{zone.today}}</td>
                <td>{{zone.total}}</td>
            </tr>
        </table>

        <v-btn color="success" block @click.prevent="refreshStats" class="mt-3">
            {{$vuetify.t('$vuetify.statistics.refresh')}}
        </v-btn>
    </div>
</template>

<script>

    export default {
        name: 'settings',

        data() {
            return {
                day: ""
            }
        },

        computed: {
            isToday() {
                return this.day === new Date().toISOString().slice(0, 10)
            },
            formattedDay() {
                const d = new Date(this.day)
                return `${d.getDate()}.${d.getMonth() + 1}.`
            }
        },

        created() {
            this.day = new Date().toISOString().slice(0, 10)
            this.$store.dispatch('loadZoneStats', this.day)
        },

        methods: {
            refreshStats() {
                this.$store.state.zoneStats.forEach(zone => {
                    zone.today = '?'
                    zone.total = '?'
                })
                this.$store.dispatch('loadZoneStats', this.day)
            },
            dayLeft() {
                this.day = new Date(new Date(this.day).getTime() - 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
                this.refreshStats()
            },
            dayRight() {
                this.day = new Date(new Date(this.day).getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
                this.refreshStats()
            }
        }
    }
</script>

<style lang="scss" scoped>
    a {
        cursor: pointer;
        color: white;
        text-decoration: none;
        display: inline-block;
        padding: 3px 7px;
        background: rgba(255, 255, 255, 0.2);
    }
    table {
        width: 100%;
        background: #444;
        td {
            padding: 3px;
            text-align: center;

            &.left {
                text-align: left;
            }
        }
    }
</style>
